module.exports = __webpack_public_path__ + "static/media/disco2.03832b7f.mp3";